import React, { Component } from "react";
import httpService from "../services/httpService";
import config from "../config.json";

class LiveContentTest extends Component {
  state = {
    tracks: [],
  };

  getTrackListHardCoded = () => {
    // Hard-coded option:
    return [
      { id: 1, title: "First track" },
      { id: 2, title: "Second track" },
    ];
  };

  async getTrackList() {
    // Replace that with a live version:
    const result = await httpService.get(config.dummyApiEndpoint);
    console.log(result);
    return result.data;
  }

  async componentDidMount() {
    // const tracks = this.getTrackListHardCoded();
    const tracks = await this.getTrackList();
    const MAX_NUMBER = 4;
    console.log("tracks are", tracks);
    // Next step: replace this with an ajax call, using jQuery or axios
    this.setState({
      tracks: tracks.slice(0, MAX_NUMBER),
    });
  }

  renderTrackList = (tracks) => {
    return (
      <React.Fragment>
        <ul>
          {tracks.map((track) => (
            <li key={track.id} className="oneTrack">
              Track: {track.title}
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  };

  render() {
    const tracks = this.state.tracks;

    return (
      <div>
        <p>
          Ok, here are tracks, rendered from a list retrieved from
          jsonplaceholder
        </p>
        {this.renderTrackList(tracks)}
      </div>
    );
  }
}

export default LiveContentTest;
